import { tableName as clientsAdvancedSearch } from '../containers/ClientsAdvancedSearch/constants';
import { tableName as dashboardAdvancedSearch } from '../containers/DashboardAdvancedSearch/constants';
import { tableName as dashboardCarriers } from '../containers/DashboardCarriers/constants';
import { tableName as dashboardClients } from '../containers/DashboardClients/constants';
import { tableName as dashboardContainersDamage } from '../containers/DashboardContainersDamage/constants';
import { tableName as dashboardDepots } from '../containers/DashboardDepots/constants';
import { tableName as dashboardEditableFields } from '../containers/DashboardEditableFields/constants';
import { tableName as dashboardNotifications } from '../containers/DashboardNotifications/constants';
import { tableName as dashboardOperations } from '../containers/DashboardOperations/constants';
import { tableName as dashboardPilots } from '../containers/DashboardPilots/constants';
import { tableName as dashboardTemplates } from '../containers/DashboardTemplates/constants';
import { tableName as dashboardUsers } from '../containers/DashboardUsers/constants';

export default {
  export: {
    failed: 'Ha ocurrido un problema exportando el archivo.',
    succeeded: 'El archivo ha sido exportado exitosamente.'
  },
  import: {
    failed: 'Ha ocurrido un problema cargando el archivo.',
    succeeded: 'El archivo ha sido cargado exitosamente.'
  },
  [clientsAdvancedSearch]: {
    load: {
      failed: 'Ha ocurrido un problema cargando los registros.'
    }
  },
  [dashboardAdvancedSearch]: {
    edit: {
      failed: 'Ha ocurrido un problema al editar el registro.',
      succeeded: 'El registro ha sido editado correctamente.'
    },
    load: {
      failed: 'Ha ocurrido un problema cargando los registros.'
    }
  },
  [dashboardCarriers]: {
    create: {
      failed: 'Ha ocurrido un problema al crear el transportista.',
      succeeded: 'El transportista ha sido creado correctamente.'
    },
    delete: {
      failed: 'Ha ocurrido un problema al eliminar el transportista.',
      succeeded: 'El transportista ha sido eliminado correctamente.'
    },
    edit: {
      failed: 'Ha ocurrido un problema al editar el transportista.',
      succeeded: 'El transportista ha sido editado correctamente.'
    },
    load: {
      failed: 'Ha ocurrido un problema cargando los transportistas.'
    }
  },
  [dashboardClients]: {
    create: {
      failed: 'Ha ocurrido un problema al crear el cliente.',
      succeeded: 'El cliente ha sido creado correctamente.'
    },
    delete: {
      failed: 'Ha ocurrido un problema al eliminar el cliente.',
      succeeded: 'El cliente ha sido eliminado correctamente.'
    },
    edit: {
      failed: 'Ha ocurrido un problema al editar el cliente.',
      succeeded: 'El cliente ha sido editado correctamente.'
    },
    load: {
      failed: 'Ha ocurrido un problema cargando los clientes.'
    }
  },
  [dashboardContainersDamage]: {
    load: {
      failed: 'Ha ocurrido un problema cargando los registros.'
    }
  },
  [dashboardDepots]: {
    create: {
      failed: 'Ha ocurrido un problema al crear el predio.',
      succeeded: 'El predio ha sido creado correctamente.'
    },
    delete: {
      failed: 'Ha ocurrido un problema al eliminar el predio.',
      succeeded: 'El predio ha sido eliminado correctamente.'
    },
    edit: {
      failed: 'Ha ocurrido un problema al editar el predio.',
      succeeded: 'El predio ha sido editado correctamente.'
    },
    load: {
      failed: 'Ha ocurrido un problema cargando los predios.',
    }
  },
  [dashboardEditableFields]: {
    edit: {
      failed: 'Ha ocurrido un problema al editar el campo.',
      succeeded: 'El campo ha sido editado correctamente.'
    },
    load: {
      failed: 'Ha ocurrido un problema cargando los campos.'
    }
  },
  [dashboardNotifications]: {
    edit: {
      failed: 'Ha ocurrido un problema al editar la notificación.',
      succeeded: 'La notificación ha sido editada correctamente.'
    },
    load: {
      failed: 'Ha ocurrido un problema cargando las notificaciones.'
    }
  },
  [dashboardOperations]: {
    load: {
      failed: 'Ha ocurrido un problema cargando la bitacora de operaciones.'
    }
  },
  [dashboardPilots]: {
    create: {
      failed: 'Ha ocurrido un problema al crear el piloto.',
      succeeded: 'El piloto ha sido creado correctamente.'
    },
    delete: {
      failed: 'Ha ocurrido un problema al eliminar el piloto.',
      succeeded: 'El piloto ha sido eliminado correctamente.'
    },
    edit: {
      failed: 'Ha ocurrido un problema al editar el piloto.',
      succeeded: 'El piloto ha sido editado correctamente.'
    },
    load: {
      failed: 'Ha ocurrido un problema cargando los pilotos.',
    }
  },
  [dashboardTemplates]: {
    edit: {
      failed: 'Ha ocurrido un problema al editar la plantilla.',
      succeeded: 'La plantilla ha sido editada correctamente.'
    },
    load: {
      failed: 'Ha ocurrido un problema cargando las plantillas.'
    }
  },
  [dashboardUsers]: {
    create: {
      failed: 'Ha ocurrido un problema al crear el usuario.',
      succeeded: 'El usuario ha sido creado correctamente.'
    },
    delete: {
      failed: 'Ha ocurrido un problema al eliminar el usuario.',
      succeeded: 'El usuario ha sido eliminado correctamente.'
    },
    edit: {
      failed: 'Ha ocurrido un problema al editar el usuario.',
      succeeded: 'El usuario ha sido editado correctamente.'
    },
    load: {
      failed: 'Ha ocurrido un problema cargando los usuarios.'
    }
  }
};



// WEBPACK FOOTER //
// ./src/shared/alertMessages.js